import {t} from 'i18next'
import React, {Fragment} from 'react'
import {PhoneTypeCt} from '../model/enums/enums'

export interface Phone {
	phone_id: number,
	phone_type: PhoneTypeCt, // mobile
	phone_number: string, // 079 123 45 67
	last_change: string,
	is_active: number,
	delete?: true
}

export interface CountryPhone {
	name: string;
	class: string;
	code: string;
}

export const phone: CountryPhone[] = [
	{name: t<string>('country.switzerland'), class: 'flag flag-ch', code: '+41'},
	{name: t<string>('country.germany'), class: 'flag flag-de', code: '+49'},
	{name: t<string>('country.italy'), class: 'flag flag-it', code: '+39'},
	{name: t<string>('country.france'), class: 'flag flag-fr', code: '+33'},
	{name: t<string>('country.spain'), class: 'flag flag-es', code: '+34'}
]

export interface PhoneType {
	value: PhoneTypeCt
	label: string
	icon: string
}

export const phoneTypes: PhoneType[] =
	[
		{label: t<string>('phone.mobile'), value: PhoneTypeCt.mobile, icon: 'fa-solid fa-phone'},
		{label: t<string>('phone.home'), value: PhoneTypeCt.home, icon: 'fa-solid fa-home'},
		{label: t<string>('phone.business'), value: PhoneTypeCt.business, icon: 'fa-solid fa-building'},
		{label: t<string>('phone.other'), value: PhoneTypeCt.other, icon: 'fa-solid fa-envelopes-bulk'}
	]

export function phoneTypeIdToName(id: PhoneTypeCt): string {
	switch (id) {
		case PhoneTypeCt.mobile:
			return t<string>('phone.mobile')
		case PhoneTypeCt.home:
			return t<string>('phone.home')
		case PhoneTypeCt.business:
			return t<string>('phone.business')
		case PhoneTypeCt.other:
			return t<string>('phone.other')
		default:
			return t<string>('phone.other')
	}
}

export const getPhoneType = (p: Phone): JSX.Element => {
	const phoneType = phoneTypes.find((phone_type: PhoneType) => phone_type.value === p.phone_type)
	if(!phoneType) {
		return <>
			<span className={'fa-solid fa-question-circle icon-dark-gray ml-auto mr-auto'}/>
		</>
	}
	return (
		<>
			<span className={`${phoneType?.icon} icon-dark-gray ml-auto mr-auto`}/>
		</>
	)
}
